import CTNButton from '@ctn/ui/components/ctn-button';
import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import classNames from 'classnames';
import { useMemo } from 'react';

import { usePageContext } from '@/context/page.context';

import type { CTNButtonProps } from '@ctn/ui/types/ctn-button';

type PageHeaderProps = {
	readonly title: string;
	readonly className?: string;
	readonly hasHelp?: boolean;
	readonly actions?: CTNButtonProps[];
};

const classNameComponente = 'c-pnp-sub-header';

const PageHeader = ({ hasHelp, title, actions, className }: PageHeaderProps) => {
	const { setIsOpenHelpModal } = usePageContext();
	const pageHeaderClassName = useMemo(() => classNames(className, classNameComponente), [className]);

	return (
		<header className={pageHeaderClassName}>
			<h2 className="c-pnp-heading-h2">
				{title}
				{hasHelp && (
					<CTNIcon
						size="md"
						icon="helpOutline"
						color="blue-50"
						className={`${classNameComponente}__action`}
						onClick={() => setIsOpenHelpModal(true)}
					/>
				)}
			</h2>
			{actions && actions.length > 0 && (
				<div className={`${classNameComponente}__action-list`}>
					{actions?.map((action) => (
						<CTNButton key={action.label} {...action} size='size-40' />
					))}
				</div>
			)}
		</header>
	);
};

export default PageHeader;
